import { CartLinesUpdateEvent } from "@shopify/events";
import { fetchConfig } from "@theme/utilities";

/**
 * THEF: upsell-rij in drawer en winkelwagenpagina. Delegatie op document, zodat het ook werkt
 * nadat Horizon de drawer opnieuw rendert (morph voert geen inline scripts uit).
 */
document.addEventListener("submit", async (event) => {
  const form =
    event.target instanceof Element
      ? event.target.closest(".thef-upsell__form")
      : null;
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector("button");
  if (button?.disabled) return;
  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll("cart-items-component")]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append("sections", sectionIds.join(","));
  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: "add",
      context: "product",
      lines: [{ merchandiseId: String(formData.get("id")), quantity: 1 }],
      promise: deferred.promise,
    }),
  );
  if (button) button.disabled = true;
  try {
    const cfg = fetchConfig("javascript", { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...cfg,
      headers: { ...cfg.headers, Accept: "text/html" },
    }).then((r) => r.json());
    const cart = await fetch(`${Theme.routes.cart_url}.json`).then((r) =>
      r.json(),
    );
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: "thef-upsell",
        itemCount: 1,
        sections: response.sections,
        didError: Boolean(response.status),
      },
    });
  } catch (error) {
    deferred.reject(error);
  } finally {
    if (button) button.disabled = false;
  }
});
